<template>
  <div class="warn1">
    <div class="warn1_title">
      <div class="popup-type1-title" :class="{ 'popup-type1-title_green': treatType }">
        <template v-if="detailData.analyzeResult && detailData.warnType == 5">{{ "道路" }}-{{ "污染识别" }}</template>
        <template
          v-else-if="detailData.warnType == 3 || detailData.warnType == 18 || detailData.warnType == 1003 || detailData.warnType == 1004 || detailData.warnType == 1005"
        >{{ detailData.eventName }}</template>
        <template v-else>
          {{ detailData.eventName
          }}{{
          (detailData.eventName &&
          detailData.eventName.indexOf(detailData.metric) > -1
          ? ""
          : "-" + detailData.metric) +
          (detailData.warnType === 1 && detailData.metric === "TSP"
          ? "-告警"
          : detailData.warnType === 1 && detailData.metric === "VDM浓度"
          ? "-告警"
          : detailData.warnType === 1
          ? "-超标"
          : detailData.warnType === 2
          ? "-超低"
          : detailData.warnType === 99
          ? "-恒值"
          : "")
          }}
        </template>
      </div>
      <div class="popup-type1-time" v-if="detailData.warnType == 5">{{ detailData.createTime ? detailData.createTime.slice(5, 16) : "" }}</div>
      <div class="popup-type1-time" v-else>{{ detailData.eventTime ? detailData.eventTime.slice(5, 16) : "" }}</div>
    </div>

    <div class="warn1_content">
      <div class="warn1_state">
        闭环控制状态:
        <span :class="{ done_green: treatType }">{{ handleState_ }}</span>
      </div>
      <div class="warn1_branchFac" v-if="detailData.branchFactory">
        所属区域:
        <span>{{ detailData.branchFactory }}</span>
      </div>
      <div class="warn1_road_info">
        发生位置:
        <span>{{ detailData.deviceName }}</span>
      </div>
      <div class="road-warn-info" v-if="detailData.warnType == 5">
        <div class="warn1_road_info">
          统计时间:
          <span>
            {{ detailData.analyzeResult.startTime }} ~
            {{
            detailData.analyzeResult.endTime
            ? detailData.analyzeResult.endTime.slice(11, 19)
            : ""
            }}
          </span>
        </div>
        <div class="warn1_road_info">
          全厂PM10均值:
          <span>
            {{
            detailData.analyzeResult.pm10AvgFactory
            ? detailData.analyzeResult.pm10AvgFactory
            : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_road_info">
          PM10均值:
          <span>
            {{
            detailData.analyzeResult.pm10AvgRoad
            ? detailData.analyzeResult.pm10AvgRoad
            : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_road_info" v-if="detailData.analyzeResult && detailData.analyzeResult.vdmAvgRoad">
          VDM均值:
          <span>{{ detailData.analyzeResult.vdmAvgRoad }} μg/m³</span>
        </div>
      </div>
    </div>
    <template v-if="detailData.warnType != 5">
      <div class="warn1_box" v-show="!treatType">
        <div class="smallBox">
          <div class="warn1_type_name">
            {{
            detailData.warnType === 20 || detailData.warnType === 21
            ? "信号名"
            : detailData.metric
            }}
          </div>
          <!-- 2022-12-13配合AUR需求新增判断warnType==20或21则展示signalName（信号名）-->
          <div class="warn1_type_num" v-if="customerId == 78 || customerId == 50 || customerId == 45">
            {{
            detailData.warnType === 99
            ? detailData.totalConstantTime
            : detailData.warnType === 20 || detailData.warnType === 21
            ? detailData.signalName
            : detailData.value
            }}
          </div>
          <div class="warn1_type_num" v-else-if="detailData.warnType !== 18">
            {{
            detailData.warnType === 99
            ? detailData.totalConstantTime
            : detailData.warnType === 20 || detailData.warnType === 21
            ? detailData.signalName
            : detailData.value
            }}
          </div>
          <div class="warn1_type_num cemsDesc" v-else>
            <p>在线监控(监测)</p>
            {{ viewData[detailData.cemsBreakdownTag] }}
          </div>
          <div class="warn1_type_unit" v-if="detailData.warnType != 18">{{ detailData.warnType === 99 ? "" : detailData.unit }}</div>
        </div>
      </div>
    </template>
    <div class="treatRecords">
      <div class="treatTitle">处理记录：</div>
      <ul class="treatList scorllTreatList">
        <li class="treatEveryList" v-for="(item, i) in treatRecords" :key="i">
          <div class="listLeft">
            <div class="listStatus">{{ item.state }}</div>
            <div class="treatMan" :title="item.receiveUserName" v-show="Boolean(item.receiveUserName)">{{ item.receiveUserName }}</div>
          </div>

          <div class="listTime">{{ item.createTime }}</div>
        </li>
      </ul>
    </div>
    <div
      class="warn1_project_33"
      :class="{
        warn1_project_66: treatRecords.length == 2,
        warn1_project_100: treatRecords.length >= 3,
      }"
    ></div>
  </div>
</template>
<script>
import getOpt from './js/chartOpt.js'
import { unwarp } from '@/utils/tools.js'
import { unref } from 'vue'

export default {
  components: {},
  props: ['detailData', 'typeId'],
  data() {
    return {
      pageInfo: 'warn1_tiny.vue',
      computedName: '闭环管理告警弹框组件',
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      handleState_: '',
      treatRecords: [],
      treatType: false,
      warnType: '',
      viewData: {
        D: '仪器仪表故障',
        B: '仪器仪表与数采通讯异常',
        VGD: '仪器仪表与数采通讯异常'
      }
    }
  },
  watch: {
    detailData: {
      handler(newVal, oldVal) {
        //this.detailData = newVal;
        this.treatType = false
        if (!this.detailData.forwards) {
          return
        }
        this.treatRecords = this.detailData.forwards
        if (this.treatRecords.length) {
          this.treatRecords.forEach((v, i) => {
            if (v.state == 1) {
              v.state = '已创建'
            } else if (v.state == 2) {
              v.state = '已处理'
            } else if (v.state == 3) {
              v.state = '已分配'
            } else if (v.state == 4) {
              v.state = '处理中'
            }
          })
        }
        if (this.detailData) {
          if (this.detailData.warnType == 1) {
            this.warnType = '超标'
          } else if (this.detailData.warnType == 2) {
            this.warnType = '超低'
          } else if (this.detailData.warnType == 3) {
            this.warnType = '同步率'
          }
        }
        if (this.detailData) {
          if (this.detailData.handleState == 0 || this.detailData.handleState == 1) {
            this.handleState_ = '处理中'
          } else if (this.detailData.handleState == 2) {
            this.handleState_ = '已处理'
            this.treatType = true
          } else if (this.detailData.handleState == 3) {
            this.handleState_ = '已撤销'
            this.treatType = true
          } else {
            this.handleState_ = '未知状态'
          }
        }
        if (this.detailData) {
          if (this.detailData.typeName && this.detailData.typeName.indexOf('微站') != -1) {
            this.detailData.typeName = '微站'
          } else if (this.detailData.typeName && this.detailData.typeName.indexOf('CEMS') != -1) {
            this.detailData.typeName = 'CEMS'
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    if (!this.detailData.forwards) {
      return
    }
    this.treatRecords = this.detailData.forwards
    if (this.treatRecords.length) {
      this.treatRecords.forEach((v, i) => {
        if (v.state == 1) {
          v.state = '已创建'
        } else if (v.state == 2) {
          v.state = '已处理'
        } else if (v.state == 3) {
          v.state = '已分配'
        } else if (v.state == 4) {
          v.state = '处理中'
        }
      })
    }
    if (this.detailData) {
      if (this.detailData.warnType == 1) {
        this.warnType = '超标'
      } else if (this.detailData.warnType == 2) {
        this.warnType = '超低'
      } else if (this.detailData.warnType == 3) {
        this.warnType = '同步率'
      }
    }
    if (this.detailData) {
      if (this.detailData.handleState == 0 || this.detailData.handleState == 1) {
        this.handleState_ = '处理中'
      } else if (this.detailData.handleState == 2) {
        this.handleState_ = '已处理'
        this.treatType = true
      } else if (this.detailData.handleState == 3) {
        this.handleState_ = '已撤销'
        this.treatType = true
      } else {
        this.handleState_ = '未知状态'
      }
    }
    if (this.detailData) {
      if (this.detailData.typeName.indexOf('微站') != -1) {
        this.detailData.typeName = '微站'
      } else if (this.detailData.typeName.indexOf('CEMS') != -1) {
        this.detailData.typeName = 'CEMS'
      }
    }
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  beforeUnmount() {},
  methods: {
    getRealityData() {
      let _this = this
      let valueHistory = this.detailData['valueHistory']
      if (valueHistory && valueHistory.length > 0 && valueHistory[0]['dps']) {
        let dps = valueHistory[0]['dps']
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: []
        }
        for (let i in dps) {
          this.noData = false
          this.pmData.xData.push(this.$moment(i * 1000).format('MM-DD hh:mm'))
          this.pmData.y1Data.push(parseFloat(dps[i].toFixed(2)))
          this.pmData.y2Data.push(0)
        }
        this.$nextTick(() => {
          if (!this.chart) {
            this.chart = echarts.init(this.$refs.chart)
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName)
          unwarp(this.chart).setOption(optionStr)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warn1 {
  position: absolute;
  padding: 20px;
  width: 430px;
  height: 441px;
  background: rgba(0, 0, 0, 0.9);
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border: 1px solid;
  border-radius: 20px;
  .warn1_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    .popup-type1-title {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #ff7373;
      line-height: 30px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &::before {
        content: '';
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
    }
  }
  .warn1_content {
    margin-top: 20px;
    .warn1_state {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      margin-bottom: 15px;
      span {
        color: #f4c48f;
        font-weight: 500;
      }
    }
    .warn1_branchFac {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 7px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .road-warn-info {
      margin-bottom: 20px;
    }
    .warn1_road_info {
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 30px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_position {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
  }
  .warn1_box {
    // margin-top: 20px;
    width: 100%;
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    padding: 13px 79px;

    .smallBox {
      @include bg-box(100%, 100px, 'warn1_bg.png');
      text-align: center;
      padding-top: 10px;
      .warn1_type_name {
        height: 16px;
        font-size: 16px;
        color: #99f5ff;
        line-height: 16px;
        margin-bottom: 15px;
      }
      .warn1_type_num {
        height: 32px;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 5px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
      }
      .cemsDesc {
        font-size: 24px;
      }
      .warn1_type_unit {
        height: 12px;
        font-size: 12px;
        color: #aaaaaa;
        line-height: 12px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
      }
    }
  }

  .treatRecords {
    width: 100%;
    // margin-top: 20px;
    height: 150px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: 'none';
    }
    .treatTitle {
      height: 18px;
      font-size: 18px;
      color: #94a2b0;
      line-height: 18px;
    }
    ul.treatList {
      padding-left: 30px;
      margin-top: 25px;
      position: relative;
      &::before {
        content: '';
        width: 1px;
        background-color: #51eeff;
        height: calc(100% - 40px);
        display: block;
        position: absolute;
        top: 20px;
        left: 15px;
      }
      li {
        height: 40px;
        border-bottom: 1px solid #4069ad;
        display: flex;
        font-size: 16px;
        color: #e8f2fc;
        line-height: 40px;
        align-items: center;
        position: relative;
        justify-content: space-between;
        .listLeft {
          display: flex;
          align-items: center;
          .listStatus {
            margin-right: 20px;
            &:before {
              content: '✔';
              color: #313131;
              line-height: 12px;
              width: 12px;
              height: 12px;
              font-size: 10px;
              top: 13px;
              background: #99f5ff;
              position: absolute;
              left: -20px;
              border-radius: 50%;
            }
          }
          .treatMan {
            width: 100px;
            height: 24px;
            background: #068acb;
            border-radius: 4px;
            line-height: 24px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    ul.scorllTreatList {
      display: inline-block;
      height: 100px;
      width: 100%;
      overflow: auto;
    }
  }
}
</style>
<style lang="scss" scoped>
.popup-type1-title_green {
  color: #30d594 !important;
  &::before {
    background: #dffff3 !important;
    box-shadow: 0px 0px 7px 0px rgba(48, 213, 148, 0.81) !important;
    border: 1px solid #30d594 !important;
  }
}
.done_green {
  color: #30d594 !important;
}
</style>
